import { useEffect, useState } from 'react';
import { listTruckClasses, type TruckClass } from '../../../../reference-data/reference-data.api';

export type TruckCataloguesState = { status: 'loading' } | { status: 'loaded'; truckClasses: TruckClass[] } | { status: 'error' };

/** The catalogue the truck create/edit form and the list's class filter read — active-only, fetched once (CLAUDE.md's small-fixed-catalogue exception to server-side paging). */
export function useTruckCatalogues(): TruckCataloguesState {
  const [state, setState] = useState<TruckCataloguesState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    listTruckClasses()
      .then((truckClasses) => {
        if (!cancelled) setState({ status: 'loaded', truckClasses: truckClasses.filter((c) => c.isActive) });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
